import { CleansingType } from "../../../../../../db/models/decontamination/index";
import ListItem, { ListViewItemData } from "../../../../../../../core/component/listView/item/index";
import { Template } from "../../../../../../../core/template/index";



export default class CleansingTypeUsageListItem extends ListItem
{
    public template = Template.lazy('/app/views/decontamination/orderItem/modals/edit-cleansing-instance/cleansing-type-usage-list-item/index.html');
    public data: CleansingTypeUsageListItemData;

    private onRemoveButtonClick(e: MouseEvent, sender: Element)
    {
        this.listView.trigger('removeCleansingTypeUsage', this);
    }
}

export interface CleansingTypeUsageListItemData extends ListViewItemData
{
    instance_id: number;
    cleansing_type_usage_id: number;
    type: CleansingType;
}